import { createAction, props } from '@ngrx/store';

import { ClientConfigurationState } from './client-configuration.state';

export const updateClientConfiguration = createAction(
	'[Client Configuration] Update',
	props<{ payload: ClientConfigurationState }>()
);

export const setLanguage = createAction('[Client Configuration] Set Language', props<{ payload: string }>());

export const setOriginUrl = createAction('[Client Configuration] Set Origin', props<{ payload: string }>());
